import React, { useContext, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import { MobileContext, ThemeOverride } from '@wix/da-shared-react/pkg/Context';
import { ThemeOptions } from '@wix/da-shared-react/pkg/publicSession/types';
import CloseButton from '@wix/da-shared-react/pkg/Button/CloseButton';

import s from './ViewAsVisitorBar.scss';

export interface Props {
  viewAsVisitor: (toggle: boolean) => void;
}

const ViewAsVisitorBar: React.FC<Props> = ({ viewAsVisitor }) => {
  const isMobile = useContext(MobileContext);
  const { t } = useTranslation();
  const onExit = useCallback(() => {
    viewAsVisitor(false);
  }, [viewAsVisitor]);

  if (typeof document === 'undefined') {
    return null;
  }

  return ReactDOM.createPortal(
    <ThemeOverride className={s['root']} theme={ThemeOptions.LIGHT}>
      <div className={s['text']}>
        {t('navigation.subnavigation.viewAsVisitor.explanation')}
      </div>
      {isMobile ? (
        <CloseButton view="b5-1" onClick={onExit} />
      ) : (
        <Button view="b14-1" onClick={onExit}>
          {t('navigation.subnavigation.viewAsVisitor.exit')}
        </Button>
      )}
    </ThemeOverride>,
    document.body
  );
};
ViewAsVisitorBar.displayName = 'ViewAsVisitorBar';

export default ViewAsVisitorBar;
